/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { connect } from 'react-redux'
import {
  Redirect,
  Route,
} from 'react-router-dom'
import { Helmet } from 'react-helmet'

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  redirectPathName = null,
  title,
  ...rest
}) => (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          return (
            <>
              {title ? (
                <Helmet
                  title={title}
                />
              ) : null}
              <Component
                {...props}
              />
            </>
          )
        }
        return (
          <Redirect
            to={{
              pathname: redirectPathName || '/login',
              state: { from: props.location },
            }}
          />
        )
      }}
    />
  )

export default connect(
  (state) => ({
    isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  }),
)(PrivateRoute)
